/** Translation bundle for shared layout copy such as tutorial headings. */
export const layoutTranslations = {
    CS: {
        layout: {tutorialsTitle: 'Načtení návodů'},
    },
    EN: {
        layout: {tutorialsTitle: 'Loading tutorials'},
    },
};
